import BaseApi from "../base";

export default class BookingRequest extends BaseApi {

}

